import { useMemo } from 'react';
import type { MatrixGroup } from '../hooks/useTithes';
import { formatMoney } from '@/features/receipts/utils/receiptFormat';

interface Props {
  groups: MatrixGroup[];
  year: number;
}

/** Year-level KPIs derived from the already-loaded matrix — no extra queries. */
export function TithesSummary({ groups, year }: Props) {
  const stats = useMemo(() => {
    const now = new Date();
    const lastDueMonth = year < now.getFullYear() ? 12 : year === now.getFullYear() ? now.getMonth() + 1 : 0;
    let total = 0, pending = 0, late = 0, noReceipt = 0;
    for (const g of groups) {
      for (const row of g.rows) {
        total += row.totalPaid;
        row.cells.forEach((c, i) => {
          if (c.outOfTenure) return;
          if (!c.tithe) { if (i + 1 <= lastDueMonth) pending++; return; }
          if (c.late) late++;
          if (!c.hasReceipt) noReceipt++;
        });
      }
    }
    return { total, pending, late, noReceipt };
  }, [groups, year]);

  const items = [
    { label: `Total ${year}`, value: `Bs. ${formatMoney(stats.total)}` },
    { label: 'Meses pendientes', value: String(stats.pending) },
    { label: 'Pagos con retraso', value: String(stats.late) },
    { label: 'Sin recibo', value: String(stats.noReceipt) },
  ];

  return (
    <div className="grid shrink-0 grid-cols-2 gap-3 lg:grid-cols-4">
      {items.map((it) => (
        <div key={it.label} className="rounded-lg border border-border bg-card px-4 py-2.5">
          <p className="text-xs text-muted-foreground">{it.label}</p>
          <p className="text-lg font-semibold">{it.value}</p>
        </div>
      ))}
    </div>
  );
}
